<template>
    <div class="relative z-10">
        <Button
            id="search-price"
            :outlined="!isDirty"
            :label="$t(`messages.transactions.hind`)"
            @click="priceFilterPopover.toggle($event)">
        </Button>
        <div class="fixed -translate-x-1/3 top-36 w-full max-w-xs">
            <Popover ref="priceFilterPopover">
                <form class="flex gap-2 items-center justify-center">
                    <div class="flex flex-col items-center gap-2">
                      <div class="flex gap-2 items-center justify-center">
                        <label class="text-nowrap text-sm">
                          <span>{{ $t(`messages.transactions.hind`) }}</span>
                        </label>
                        <span></span>
                        <SelectButton
                            :options="modeOptions"
                            v-model="mode"
                            @update:model-value="setMode"
                            option-label="label"
                            option-value="value"
                            :allow-empty="false"
                            size="small"
                            :pt="{
                              pcToggleButton: {
                                content: 'py-0 px-1'
                              }
                            }"
                            :pt-options="{
                              mergeProps: true
                            }"
                          />
                      </div>
                        <div class="flex gap-2">
                          <InputNumber
                              :placeholder="$t(`messages.transactions.from`)"
                              v-model="priceFrom"
                              inputmode="numeric"
                              size="small"
                              currency="EUR"
                              :currency-display="'symbol'"
                              locale="et-EE"
                              :min-fraction-digits="0"
                              :pt="fromToPT"
                              @update:model-value="updateValue()"
                          />
                          <InputNumber
                              :placeholder="$t(`messages.transactions.to`)"
                              v-model="priceTo"
                              inputmode="numeric"
                              size="small"
                              currency="EUR"
                              :currency-display="'symbol'"
                              locale="et-EE"
                              :min-fraction-digits="0"
                              :pt="fromToPT"
                              @update:model-value="updateValue()"
                          />
                        </div>
                    </div>
                </form>
            </Popover>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  from: {
    type: [String, Number],
    default: null,
  },
  to: {
    type: [String, Number],
    default: null,
  },
})

const isOpen = ref(false)
const priceFilterPopover = ref(null)
const priceFrom = ref(null)
const priceTo = ref(null)
const mode = ref('total')
const unitType = ref('apartment')

const modeOptions = ref([
  { label: t('messages.transactions.filters.mode.total'), value: 'total' },
  { label: t('messages.transactions.filters.mode.unit'), value: 'unit' },
])

const fromToPT = ref({
  root: {
    class: 'w-32',
  },
  pcInputText: {
    root: {
      class: 'w-32',
    },
  },
})

// Watch for changes in props
watch(
  () => props.from,
  val => {
    priceFrom.value = val
  },
)

watch(
  () => props.to,
  val => {
    priceTo.value = val
  },
)

const emit = defineEmits(['change'])

const updateValue = () => {
  emit('change', {
    from: priceFrom.value,
    to: priceTo.value,
    mode: mode.value,
    unitType: unitType.value,
  })
}

const setMode = (newMode) => {
  mode.value = newMode
  updateValue()
}

const setUnitType = (type) => {
  unitType.value = type
  updateValue()
}

const isDirty = computed(() => {
  return priceFrom.value !== null || priceTo.value !== null
})

onMounted(() => {
  priceFrom.value = props.from
  priceTo.value = props.to
})
</script>

<style scoped>
:deep(.p-togglebutton-checked .p-togglebutton-content) {
  background: var(--p-primary-color) !important;
  color: var(--p-primary-contrast-color) !important;
}

:deep(.p-togglebutton.p-togglebutton-checked) {
  background: var(--p-primary-color) !important;
  border-color: var(--p-primary-color) !important;
}

:deep(.p-togglebutton-sm) {
  font-size: 0.75rem !important;
  line-height: 0.85rem !important;
}
</style>